<template>
  <div class="file-template-list" v-loading="loading">
    <div class="header">
      <div class="title">常用模板</div>

      <common-search-input
        v-model="formInfo.fileName"
        placeholder="搜索模板"
        @search="onSearch"
        @input="onSearch"
      />
    </div>

    <div class="content" v-loading="searchLoading">
      <file-template-breadcrumb
        class="file-breadcrumb"
        v-model="currentFolderToken"
        :breadcrumb-list="breadcrumbList"
        :is-search="!!formInfo.fileName"
        @update="updateBreadcrumbList"
      >
      </file-template-breadcrumb>
      <template>
        <div class="file-template-item-list" v-if="fileList.length">
          <file-template-item
            v-for="(fileItem, index) in fileList"
            :key="index"
            :file-item="fileItem"
            @click.native="onClickFileItem(fileItem)"
          ></file-template-item>
        </div>

        <el-empty
          description="暂无数据"
          class="file-template-empty-box"
          v-else
        ></el-empty>
      </template>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash';

import workWxCommonService from '../services/work-wx-common-service';
import fileTemplateListApi from '../api/file-template-list-api';
import fileTemplateBreadcrumb from './components/file-template-breadcrumb.vue';
import fileTemplateItem from './components/file-template-item.vue';
import commonSearchInput from '../components/common/common-search-input.vue';

export default {
  components: {
    fileTemplateBreadcrumb,
    fileTemplateItem,
    commonSearchInput,
  },
  data() {
    return {
      loading: true,
      searchLoading: false,
      formInfo: {
        fileName: '',
      },
      fileList: [], // 展示的文件列表
      currentFolderToken: undefined,
      breadcrumbList: [],
      layout: {
        requestId: 0,
      },
    };
  },
  created() {
    workWxCommonService
      .commonLogin()
      .then(() => {
        this.init();
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    init() {
      this.getFileList();
    },
    async getFileList() {
      try {
        this.loading = true;
        const res = await fileTemplateListApi.getFeishuFolderFileList({
          folder_token: this.currentFolderToken,
        });
        this.fileList = res.file_list || [];
      } finally {
        this.loading = false;
      }
    },
    onSearch: debounce(async function search() {
      try {
        if (!this.formInfo.fileName) {
          // 清空搜索, 重新请求文件夹数据
          this.getFileList();
          return;
        }
        const requestId = ++this.layout.requestId;
        // 搜索
        this.searchLoading = true;
        const res = await fileTemplateListApi.searchFileList({
          filename: this.formInfo.fileName,
        });
        // 如果请求id不一致, 说明有新的搜索请求, 则不更新数据
        if (requestId !== this.layout.requestId) {
          return;
        }
        this.fileList = res.file_list || [];
        this.searchLoading = false;
      } catch (error) {
        this.fileList = [];
        this.searchLoading = false;
      }
    }, 300),
    onClickFileItem(templateItem) {
      // 如果非文件夹
      if (templateItem.type !== 'folder') return;
      this.currentFolderToken = templateItem.token;
      // 更新面包屑列表
      this.breadcrumbList.push({
        label: templateItem.name,
        folder_token: templateItem.token,
      });
      this.getFileList();
    },
    // 更新面包屑列表
    updateBreadcrumbList() {
      // 根据currentFolderToken获取面包屑列表
      const lastIndex = this.breadcrumbList.findIndex(
        (item) => item.folder_token === this.currentFolderToken,
      );
      this.breadcrumbList = this.breadcrumbList.slice(0, lastIndex + 1);
      this.formInfo.fileName = '';
      this.getFileList(); // 重新获取列表
    },
  },
};
</script>

<style lang="less">
.file-template-empty-box {
  &.el-empty {
    padding-top: 100px;
    .el-empty__image {
      width: 120px;
    }
  }
}
</style>
<style lang="less" scoped>
.file-template-list {
  font-size: 14px;
  background: #fff;
  height: 100vh;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    border-bottom: 1px solid #ddd;
    .title {
      font-weight: 600;
      font-size: 16px;
    }
  }
  .content {
    .file-breadcrumb {
      padding: 12px 20px;
      background: #eee;
    }
    .file-template-item-list {
      display: flex;
      flex-wrap: wrap;
      > div {
        padding: 12px 20px;
        border-top: 1px solid #ededed;
        &:hover {
          background: #f0f2f7;
        }
        &:first-child {
          border-top: 0;
        }
      }
    }
  }
}
</style>
